import { ModuleWithProviders, NgModule } from '@angular/core'
import { OrderService } from '@ftr/ui-ordering'
import { TimeRangeService } from '@ftr/ui-playback'

@NgModule({
  providers: [OrderService],
})
export class OrderServiceModule {
  static forRoot(): ModuleWithProviders<OrderServiceModule> {
    return {
      ngModule: OrderServiceModule,
      providers: [TimeRangeService],
    }
  }
}
